// SVG path data for the Nula logo / emblem. Shared by LogoAnimated and
// EmblemAnimated so both components stay in lockstep when the brand mark is
// updated. Coordinates live in the original logo coordinate space (700,430)
// at the top-left, 580×220 for the full lockup. The emblem occupies roughly
// (708, 453) → (882, 627) within that space.

// Full-precision emblem path, derived from the source artwork
// (assets/Logo files/Emblem/SVG/Asset 1.svg) and transformed into this lockup
// coordinate space — translate(708.4089,453.1289) scale(0.225760) maps the
// source circle (center 384.795, r 384.79) onto the orb (center 795.28,540,
// r 86.87). Same position/size as before; the prior path was a low-res
// re-trace that rendered with rugged edges.
export const ORB_FILL =
  'M795.281,453.129C747.379,453.129,708.409,492.097,708.409,539.999s38.971,86.87,86.872,86.87,86.872-38.968,86.872-86.87S843.183,453.129,795.281,453.129ZM833.954,564.945c-5.082,5.016-9.123,11.9-13.401,19.185-8.412,14.333-16.365,27.85-31.451,26.96-26.879-1.619-52.728-22.039-61.461-48.556-6.956-21.118-3.705-43.937,8.92-62.608,12.342-18.25,31.771-29.505,53.313-30.873,1.531-0.097,3.052-0.144,4.569-0.144,35.684,0,67.215,26.536,71.408,61.023,1.795,14.751-6.509,19.262-17.018,24.974-5.147,2.797-10.468,5.687-14.88,10.04Z';

// Orb outer circle only — single continuous path so getTotalLength gives one
// tip. Used by the stroke layer's draw-on animation; the inner "wing" cutout
// from ORB_FILL is left out of the stroke so the dasharray traces just the
// outer ring once.
export const ORB_STROKE_CIRCLE =
  'M795.28,453.13a86.87,86.87,0,1,1-86.87,86.87,86.87,86.87,0,0,1,86.87-86.87Z';

// Letterform paths (full logo).
export const N =
  'M999.09,579.22h-14.7v-39.76c0-8.15-2.06-14.36-6.19-18.64-4.13-4.28-9.75-6.42-16.86-6.42s-12.74,2.14-16.86,6.42c-4.13,4.28-6.19,10.5-6.19,18.64v39.76h-14.7v-39.76c0-12.48,3.4-22.04,10.21-28.7,6.81-6.65,15.99-9.98,27.54-9.98s20.73,3.3,27.54,9.9c6.81,6.6,10.21,16.19,10.21,28.77v39.76Z';

export const U =
  'M1072.78,542.71v-39.92h14.7v39.92c0,12.38-3.4,21.89-10.21,28.54-6.81,6.65-15.99,9.98-27.54,9.98s-20.73-3.3-27.54-9.9c-6.81-6.6-10.21-16.14-10.21-28.62v-39.92h14.7v39.92c0,8.15,2.06,14.34,6.19,18.57,4.12,4.23,9.75,6.34,16.86,6.34s12.74-2.11,16.86-6.34c4.12-4.23,6.19-10.42,6.19-18.57Z';

export const L = 'M1117.47,579.22h-14.7v-109.85h14.7v109.85Z';

export const A =
  'M1211.6,541.63v37.59h-13.46v-15.94h-.31c-2.37,5.47-6.16,9.82-11.37,13.07-5.21,3.25-11.27,4.87-18.18,4.87-10.52,0-19.6-3.61-27.23-10.83-7.63-7.22-11.45-17.02-11.45-29.39,0-11.65,3.84-21.27,11.53-28.85,7.68-7.58,17.56-11.37,29.63-11.37s21.89,3.77,29.47,11.29c7.58,7.53,11.37,17.38,11.37,29.55ZM1151.73,560.19c4.85,4.95,11.19,7.43,19.03,7.43s14.18-2.48,19.03-7.43c4.85-4.95,7.27-11.34,7.27-19.18s-2.42-14.23-7.27-19.18c-4.85-4.95-11.19-7.43-19.03-7.43s-14.18,2.48-19.03,7.43c-4.85,4.95-7.27,11.35-7.27,19.18s2.42,14.23,7.27,19.18Z';

// Orb-only viewBox: crop of the emblem within the full logo coordinate
// space. The fill reveal circle is centred at (795.28, 540) with max radius
// 92; the orb itself is r=86.87 and the stroke adds ~5 more units to each
// side. The box leaves room for the stroke + a small breathing margin so
// rounded linecaps don't clip at the bounding edge.
export const ORB_VIEW_BOX = '696 441 198 198';

// Reveal-clip geometry for the draw-on animation.
export const ORB_REVEAL_CENTER = { cx: 795.28, cy: 540 } as const;
export const ORB_REVEAL_MAX_R = 92;
